import Axios from "axios";
import {
  SET_CURRENCY_LIST,
  UNSET_CURRENCY_LIST,
} from "@/store/mutation-types";
import { getCurrencyList } from "@/store/api";

const state = {
  currencyList: [],
};

const getters = {
  getCurrencyList(state) {
    return state.currencyList;
  },
};

const mutations = {
  [SET_CURRENCY_LIST](state, data) {
    state.currencyList = data;
  },
  [UNSET_CURRENCY_LIST](state) {
    state.currencyList = [];
  },
};

const actions = {
  getCurrencyList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getCurrencyList)
        .then(function (response) {
          commit("SET_CURRENCY_LIST", response.data.currency);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_CURRENCY_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

